import { Length, Unit } from "./box";
import { TemplateLocale } from "./common";

export enum TextAlignHorizontal {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right",
}

export enum TextAlignVertical {
  TOP = "top",
  MIDDLE = "middle",
  BOTTOM = "bottom",
}

export type TextAlign = [TextAlignVertical, TextAlignHorizontal];

export class UnsupportedTextAlignError extends Error {
  constructor(value: string) {
    super(`Unsupported TextAlign "${value}"`);
  }
}

export enum TextOrientation {
  O000 = 0,
  O090 = 90,
  O180 = 180,
  O270 = 270,
}

export class UnsupportedTextOrientationError extends Error {
  constructor(value: string) {
    super(`Unsupported TextOrientation "${value}"`);
  }
}

export interface LocalizedContent {
  content: string;
  locale: TemplateLocale;
}

export interface ZoomedPage {
  textOrientation: TextOrientation;
}

export interface Textable {
  fontSize: Length<Unit.P10K>;
  lineHeight: Length<Unit.P10K>;

  fontColorKey: string;

  textOrientation: TextOrientation;
  textAlign: TextAlign;
}
